import { Fragment, useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { Popover, Transition } from "@headlessui/react";
import { Download, Edit, Trash } from "lucide-react";
import APIS from "../../../constant/Endpoint";
import { getApiData } from "../../../helpers/AxiosInstance";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const Options = ({
  setOpenRenameFolderPopup,
  setSelected,
  folder,
  handleDelete,
  isdeleteLoading,
}) => {
  const handleDownload = async (id: string) => {
    const url = APIS.FILE;
    const param = { object_id: id };

    try {
      const res = await getApiData(url, param);

      if (res?.status === 200 && Array.isArray(res?.data)) {
        const zip = new JSZip();
        const files = res.data;

        for (const file of files) {
          const response = await fetch(file?.file);
          const blob = await response.blob();
          zip.file(file.title || `file_${Date.now()}`, blob);
        }

        const zipBlob = await zip.generateAsync({ type: "blob" });
        saveAs(zipBlob, `${folder?.title || "download"}.zip`);
      }
    } catch (err) {
      console.error("Download error:", err);
    }
  };
  return (
    <div className={tw``}>
      <Popover className={tw`relative`}>
        {({ open }) => (
          <>
            <Popover.Button
              className={tw`flex gap-x-2  rounded  focus:outline-none `}
            >
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>{" "}
                </g>
              </svg>
            </Popover.Button>
            <Transition
              as={Fragment}
              enter={tw`transition ease-out duration-200`}
              enterFrom={tw`opacity-0 translate-y-1`}
              enterTo={tw`opacity-100 translate-y-0`}
              leave={tw`transition ease-in duration-150`}
              leaveFrom={tw`opacity-100 translate-y-0`}
              leaveTo={tw`opacity-0 translate-y-1`}
            >
              <Popover.Panel
                className={tw`absolute z-10 mt-4 max-w-sm w-60 px-4 -mx-[20px]`}
                style={{
                  maxHeight: "calc(100vh - 20px)",
                  overflowY: "auto",
                  right: 0,
                  left: "auto",
                }}
              >
                <div className={tw`w-52 bg-white py-2  shadow rounded`}>
                  <ul>
                    <li>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenRenameFolderPopup(true);
                          setSelected({ id: folder?.id, title: folder?.title });
                        }}
                        className={tw`flex gap-x-2 items-center w-full px-4 py-1 focus:outline-none rounded hover:bg-gray-200 `}
                      >
                        <Edit />
                        Rename
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={(e) => {
                          e.stopPropagation(), handleDownload(folder?.id);
                        }}
                        className={tw`flex gap-x-2 items-center w-full px-4 py-1 focus:outline-none rounded hover:bg-gray-200 `}
                      >
                        <Download />
                        Download
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        disabled={isdeleteLoading || false}
                        onClick={(e) => {
                          e.stopPropagation(), handleDelete(folder?.id);
                        }}
                        className={tw`flex gap-x-2 items-center w-full px-4 py-1 focus:outline-none rounded hover:bg-gray-200 `}
                      >
                        <Trash />
                        Delete
                      </button>
                    </li>
                  </ul>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
};

export default Options;
